function getRuntimeConfiguredApiUrl(): string | undefined {
  const valueFromImportMeta = import.meta.env?.VITE_API_URL
  if (valueFromImportMeta && valueFromImportMeta.trim().length > 0) {
    return valueFromImportMeta.trim()
  }

  if (typeof window !== 'undefined') {
    const fromWindow = (window as Window & { __RH_API_URL?: string })
      .__RH_API_URL
    if (fromWindow && fromWindow.trim().length > 0) {
      return fromWindow.trim()
    }
  }

  if (typeof globalThis !== 'undefined') {
    const fromGlobal = (globalThis as { __RH_API_URL?: string }).__RH_API_URL
    if (fromGlobal && fromGlobal.trim().length > 0) {
      return fromGlobal.trim()
    }
  }

  return undefined
}

function stripTrailingSlash(url: string): string {
  return url.endsWith('/') ? url.slice(0, -1) : url
}

/**
 * Resolves the API base URL from environment variables, runtime config,
 * or window.location.origin as a production fallback.
 */
export function resolveApiBaseUrl(): string {
  const configured = getRuntimeConfiguredApiUrl()
  if (configured) {
    return stripTrailingSlash(configured)
  }

  if (
    typeof window !== 'undefined' &&
    window.location &&
    import.meta.env?.DEV !== true
  ) {
    return stripTrailingSlash(window.location.origin)
  }

  const fromProcess =
    typeof process !== 'undefined' && typeof process.env !== 'undefined'
      ? process.env.VITE_API_URL || process.env.API_URL
      : undefined

  if (fromProcess && fromProcess.trim().length > 0) {
    return stripTrailingSlash(fromProcess.trim())
  }

  throw new Error(
    'Unable to resolve API base URL. Set VITE_API_URL in your environment.'
  )
}
